
import { Vue, Component } from "vue-property-decorator";
import {
  SettingsCardsProfile,
  SettingsCardsOther,
  SettingsCardsPersonal,
  defaultUserInfo
} from "@/helpers/constants";
import SettingsCard from "@/components/settings/components/settingsPage/SettingsCard.vue";
import { Mutation } from "vuex-class";
import {
  SettingsCardInfo,
  SettingsCardSections,
  SettingsMutations,
  SettingsTitle
} from "@/components/settings/types";
import { Namespace } from "@/store/types";
import { UserInfo, UserRole } from "@/services/apiService/api.types";
import SettingsCardProfile from "@/components/settings/components/settingsPage/SettingsCardProfile.vue";
import apiService from "@/services/apiService/apiService";
import SettingsCardNew from "@/components/settings/components/settingsPage/SettingsCardNew.vue";
import {
  LocaleSettingsCardsOther,
  LocaleSettingsCardsPersonal,
  LocaleSettingsCardsProfile,
  LocaleSettingsPageSectionTitles,
  LocaleSettingsPageTitles
} from "@/plugins/i18n/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import apiStorageInterface from "@/services/apiStorageInterface";

@Component({
  components: {
    SettingsCard,
    SettingsCardProfile,
    SettingsCardNew
  }
})
export default class SettingsOptions extends Vue {
  @Mutation(SettingsMutations.setSettingsPageTitle, {
    namespace: Namespace.Settings
  })
  setSettingsPageTitle!: (settingsPageTitle?: SettingsTitle) => void;

  @Mutation(SettingsMutations.setEncodedPin, { namespace: Namespace.Settings })
  setEncodedPin!: (pin: string) => void;

  cardSections = SettingsCardSections;
  userChildren: UserInfo[] = [];
  userRole = UserRole;

  LocaleSettingsPageSectionTitles = LocaleSettingsPageSectionTitles;

  userInfo: UserInfo = defaultUserInfo;

  created(): void {
    this.setSettingsPageTitle({
      heading: i18n.t(LocaleSettingsPageTitles.settingsHomeTitle) as string,
      subHeading: i18n.t(
        LocaleSettingsPageTitles.settingsHomeSubTitle
      ) as string
    });
    this.setEncodedPin("");
    this.refreshUserList();
  }

  async mounted(): Promise<void> {
    this.userInfo = await apiStorageInterface.fetchUserInfo();
  }

  //making translations reactive
  get settingsCardsPersonal(): SettingsCardInfo[] {
    let translatedSettingsCardsPersonal = SettingsCardsPersonal;
    translatedSettingsCardsPersonal.forEach((item, index) => {
      switch (index) {
        case 0:
          item.settingsCardTitle.subHeading = i18n.t(
            LocaleSettingsCardsPersonal.logout
          ) as string;
          break;
        case 1:
          item.settingsCardTitle.subHeading = i18n.t(
            LocaleSettingsCardsPersonal.restart
          ) as string;
          item.rightSideMenuTitle = {
            heading: i18n.t(LocaleSettingsCardsPersonal.restart) as string,
            subHeading: ""
          };
          break;
        case 2:
          item.settingsCardTitle = {
            heading: i18n.t(
              LocaleSettingsCardsPersonal.languageHeading
            ) as string,
            subHeading: i18n.t(
              LocaleSettingsCardsPersonal.languageSubHeading
            ) as string
          };
          item.rightSideMenuTitle = {
            heading: i18n.t(
              LocaleSettingsCardsPersonal.languageHeading
            ) as string,
            subHeading: i18n.t(
              LocaleSettingsCardsPersonal.languageSubHeading
            ) as string
          };
          break;
        case 3:
          item.settingsCardTitle = {
            heading: i18n.t(LocaleSettingsCardsPersonal.pinHeading) as string,
            subHeading: i18n.t(
              LocaleSettingsCardsPersonal.pinSubHeading
            ) as string
          };
          item.rightSideMenuTitle = {
            heading: i18n.t(LocaleSettingsCardsPersonal.pinHeading) as string,
            subHeading: i18n.t(
              LocaleSettingsCardsPersonal.pinSubHeading
            ) as string
          };
          break;
      }
    });

    return translatedSettingsCardsPersonal;
  }

  get settingsCardsProfile(): SettingsCardInfo {
    let translatedSettingsCardsProfile = SettingsCardsProfile;
    translatedSettingsCardsProfile.settingsCardTitle = {
      heading: i18n.t(LocaleSettingsCardsProfile.userHeading) as string
    };

    return translatedSettingsCardsProfile;
  }

  get settingsCardsOther(): SettingsCardInfo[] {
    let translatedSettingsCardsOther = SettingsCardsOther;
    translatedSettingsCardsOther.forEach((item, index) => {
      switch (index) {
        case 0:
          item.settingsCardTitle = {
            heading: i18n.t(
              LocaleSettingsCardsOther.sortAndLockHeading
            ) as string,
            subHeading: i18n.t(
              LocaleSettingsCardsOther.sortAndLockSubHeading
            ) as string
          };
          break;
        case 1:
          item.settingsCardTitle = {
            heading: i18n.t(LocaleSettingsCardsOther.supportHeading) as string,
            subHeading: i18n.t(
              LocaleSettingsCardsOther.supportSubHeading
            ) as string
          };
          item.rightSideMenuTitle = {
            heading: i18n.t(
              LocaleSettingsCardsOther.supportHeadingRightSideMenu
            ) as string,
            subHeading: ""
          };
          break;
      }
    });

    return translatedSettingsCardsOther;
  }

  async refreshUserList(): Promise<void> {
    const { children } = await apiService.getUserChildrenInfo();
    this.userChildren = children;
  }
}
